import {
  Create,
  Datagrid,
  Edit,
  EditButton,
  Filter,
  List,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput,
  required,
} from 'react-admin';

import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import React from 'react';
import { stringify } from 'query-string';
import { useTranslate } from 'react-admin';

const CategoriesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Поиск" source="q" alwaysOn />
    <ReferenceInput
      label="Производитель"
      source="manufacturer_q"
      reference="heater-manufacturers"
      allowEmpty
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const LinkToRelatedProducts = ({ record }) => {
  const translate = useTranslate();
  return (
    <Button
      size="small"
      color="primary"
      component={Link}
      to={{
        pathname: '/heater-items',
        search: stringify({
          page: 1,
          perPage: 25,
          filter: JSON.stringify({ category_q: record?.id }),
        }),
      }}
    >
      {translate('resources.categories.fields.items')}
    </Button>
  );
};

export const HeaterCategoriesList = (props) => (
  <List filters={<CategoriesFilter />} {...props} title={props.options.label}>
    <Datagrid>
      <TextField source="name" label="Название категории" />
      <ReferenceField
        label="Производитель"
        source="manufacturer"
        reference="heater-manufacturers"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="order" label="Порядок" />
      <LinkToRelatedProducts />
      <EditButton />
    </Datagrid>
  </List>
);

const CategoriesTitle = ({ record }) => {
  return <span>Категория {record ? `"${record.name}"` : ''}</span>;
};

export const HeaterCategoriesEdit = (props) => (
  <Edit title={<CategoriesTitle />} {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Производитель"
        source="manufacturer"
        reference="heater-manufacturers"
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput
        source="name"
        label="Название категории"
        validate={[required()]}
      />
      <TextInput source="description" label="Описание" multiline fullWidth />
      <NumberInput
        source="order"
        label="Порядок"
        min={1}
        max={99}
        step={1}
        validate={[required()]}
      />
    </SimpleForm>
  </Edit>
);

export const HeaterCategoriesCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Производитель"
        source="manufacturer"
        reference="heater-manufacturers"
        validate={[required()]}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput
        source="name"
        label="Название категории"
        validate={[required()]}
      />
      <TextInput source="description" label="Описание" multiline fullWidth />
      <NumberInput
        source="order"
        label="Порядок"
        min={1}
        max={99}
        step={1}
        validate={[required()]}
      />
    </SimpleForm>
  </Create>
);
